import { render, staticRenderFns } from "./AdministratorCreate.vue?vue&type=template&id=45ade6b4&scoped=true&"
import script from "./AdministratorCreate.vue?vue&type=script&lang=js&"
export * from "./AdministratorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ade6b4",
  null
  
)

export default component.exports